document.addEventListener('DOMContentLoaded', function () {
  var openButtons = document.querySelectorAll('[data-yonow-size-guide-open]');

  if (!openButtons.length) return;

  function updateScrollHints(modal) {
    if (!modal) return;

    modal.querySelectorAll('.yonow-size-guide-source').forEach(function (source) {
      var isScrollable = source.scrollWidth > source.clientWidth + 12;
      source.classList.toggle('is-scrollable', isScrollable);
    });
  }

  function openModal(modal) {
    if (!modal) return;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('yonow-size-guide-lock');
    document.body.classList.add('yonow-size-guide-lock');

    setTimeout(function () {
      updateScrollHints(modal);
    }, 80);
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('yonow-size-guide-lock');
    document.body.classList.remove('yonow-size-guide-lock');
  }

  function switchPanel(modal, panelName) {
    if (!modal) return;

    var tabs = modal.querySelectorAll('[data-yonow-panel-tab]');
    var panels = modal.querySelectorAll('[data-yonow-panel]');

    tabs.forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-yonow-panel-tab') === panelName);
    });

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-yonow-panel') === panelName);
    });

    setTimeout(function () {
      updateScrollHints(modal);
    }, 80);
  }

  openButtons.forEach(function (openBtn) {
    openBtn.addEventListener('click', function () {
      var wrapper = openBtn.closest('.yonow-size-label') || document;
      var modal =
        wrapper.querySelector('[data-yonow-size-guide-modal]') ||
        document.querySelector('[data-yonow-size-guide-modal]');

      openModal(modal);
    });
  });

document.addEventListener('click', function (event) {
  var closeTrigger = event.target.closest('[data-yonow-size-guide-close]');
  var panelTrigger = event.target.closest('[data-yonow-panel-tab]');
  var modalOuter = event.target.closest('[data-yonow-size-guide-modal]');

  if (closeTrigger) {
    var modalToClose = closeTrigger.closest('[data-yonow-size-guide-modal]');
    closeModal(modalToClose);
    return;
  }

  if (
    event.target.matches('[data-yonow-size-guide-overlay]') ||
    event.target.matches('[data-yonow-size-guide-modal]')
  ) {
    closeModal(modalOuter || event.target);
    return;
  }

  if (panelTrigger) {
    var modalForPanel = panelTrigger.closest('[data-yonow-size-guide-modal]');
    var panelName = panelTrigger.getAttribute('data-yonow-panel-tab');
    switchPanel(modalForPanel, panelName);
  }
});

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-yonow-size-guide-modal].is-open').forEach(function (modal) {
      closeModal(modal);
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-yonow-size-guide-modal].is-open').forEach(function (modal) {
      updateScrollHints(modal);
    });
  });
});